import MoaPanel from "./moa_panel";
import { MoaFormAnatomy, MOA_FORM_BASE_HTML_CLASS, renderStatusHint } from "../helpers/moa_panel_hints";

// PasswordForm — password entry (the email belongs to a password User). Submit →
// host.submitPassword (XHR verify_password, no page nav); Forgot? → host.openForgot
// (the in-card reset panel); Back → host.changeEmail. The hidden auth_username mirror
// carries the email so password managers associate the saved credential.
export const PasswordFormConfig = {
  componentTypeKey: "MoaPasswordForm",
  baseHtmlClass: MOA_FORM_BASE_HTML_CLASS,
  selector: ".member_offer_acceptor__form--password",
  phase: "password",

  passwordInputSelector: ".member_offer_acceptor__form__field--password input",
  // Selected by NAME on purpose: the name attribute IS the point of this field — it's the
  // hidden username mirror password managers look for to pair with the password.
  emailMirrorSelector: "input[name=auth_username]",
  hintSelector: MoaFormAnatomy.hintSelector,
  backButtonSelector: MoaFormAnatomy.backButtonSelector,
  forgotButtonSelector: ".member_offer_acceptor__foot__item--forgot button",
};

export class PasswordForm extends MoaPanel {
  static get config() { return PasswordFormConfig; }

  constructor(id_or_element, host) {
    super(id_or_element, host, PasswordFormConfig);

    this.passwordInput = this.element.querySelector(PasswordFormConfig.passwordInputSelector);
    this.emailMirror = this.element.querySelector(PasswordFormConfig.emailMirrorSelector);
    this.hintEl = this.element.querySelector(PasswordFormConfig.hintSelector);
    this.backButton = this.element.querySelector(PasswordFormConfig.backButtonSelector);
    this.forgotButton = this.element.querySelector(PasswordFormConfig.forgotButtonSelector);
    this.defaultHint = this.hintEl.textContent;

    this.element.addEventListener("submit", this.handleSubmit.bind(this));
    this.backButton.addEventListener("click", this.handleBack.bind(this));
    this.forgotButton.addEventListener("click", this.handleForgot.bind(this));
  }

  handleSubmit(event) {
    event.preventDefault();
    this.host.submitPassword(this.passwordInput.value);
  }

  handleBack(event) {
    event.preventDefault();
    this.host.changeEmail();
  }

  handleForgot(event) {
    event.preventDefault();
    this.host.openForgot();
  }

  render() {
    this.renderPanelVisibility();

    this.passwordInput.disabled = !!this.readStateMachineValue("authBusy");
    this.emailMirror.value = this.readStateMachineValue("authEmail") || "";

    renderStatusHint(this.hintEl, this.readStateMachineValue("authStatus"), this.defaultHint);
  }
}
